// Presentation only: bot identity and gameplay state remain server-controlled.
// REMOVE ALL BOTS BEFORE LAUNCH — bots are test opponents only.
const BOT_AVATAR_COUNT = 8;

export function getBotAvatarUrl(player) {
  const name = String(player?.username || player?.name || player?.userId || 'test-opponent');
  // Stable FNV-1a hash: a given player name always maps to the same local avatar.
  let hash = 2166136261;
  for (let i = 0; i < name.length; i += 1) {
    hash ^= name.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  const index = (hash >>> 0) % BOT_AVATAR_COUNT;
  return `/bot-avatars/whot-avatar-${String(index + 1).padStart(2, '0')}.svg`;
}
